module.exports = __webpack_public_path__ + "img/time.5bceb5f6.svg";